module.exports = __webpack_public_path__ + "img/base.c39d28cb.png";